import { IconSearch } from "@/Icon/Search";

interface SearchBoxProps {
  placeholder?: string;
  onSearch?: (value: string) => void;
  className?: string;
  searchText?: string;
  setSearchText?: React.Dispatch<React.SetStateAction<string>>;
}

const SearchBox = ({
  placeholder = "검색어를 입력하세요",
  onSearch,
  className = "",
  searchText,
  setSearchText,
}: SearchBoxProps) => {
  // const [searchText, setSearchText] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchText?.(value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      onSearch?.(searchText || "");
    }
  };

  return (
    <div className={`w-full rounded-lg border-2 border-gray-200 ${className}`}>
      <div className="flex items-center w-full bg-white rounded-lg">
        <input
          type="text"
          value={searchText}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          className="py-2 pr-4 pl-4 w-full text-sm placeholder-gray-400 bg-transparent rounded-full border-none focus:outline-none focus:ring-0"
        />
        <button className="mr-3" onClick={() => onSearch?.(searchText || "")}>
          <IconSearch />
        </button>
      </div>
    </div>
  );
};

export default SearchBox;
